import { createFileRoute } from '@tanstack/react-router';

import { LogoutPage } from '../logout/LogoutPage';

export const Route = createFileRoute('/logout')({
    component: LogoutPage,
});
